import { render, staticRenderFns } from "./TrTextBlockWithInputV2.vue?vue&type=template&id=f56c97b0&scoped=true&"
import script from "./TrTextBlockWithInputV2.vue?vue&type=script&lang=js&"
export * from "./TrTextBlockWithInputV2.vue?vue&type=script&lang=js&"
import style0 from "./TrTextBlockWithInputV2.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TrTextBlockWithInputV2.vue?vue&type=style&index=1&id=f56c97b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56c97b0",
  null
  
)

export default component.exports